import { AppData, Utils } from "@lightningjs/sdk";
import { AppSetup } from "./app-setup";
import { Helper } from "./helper";
import { fetchData } from "./models/data-service";
import AppModel from "./models/app-model";
import axios from "axios";

export class Logger {
    // User action log capture such as new, exit, fetch etc.
    static logUserAction = (actionDetails: any) => {
        Logger.printLog('data', 'calling user action logger: ', actionDetails);
        var jsonURL = 'q=user';
        if (actionDetails !== undefined) {

            if (Helper.isValidValue(actionDetails.actiontype)) {
                jsonURL += '&actiontype=' + actionDetails.actiontype;
            } else {
                jsonURL += '&actiontype=';
            }

            if (Helper.isValidValue(actionDetails.actionkey)) {
                jsonURL += '&actionkey=' + actionDetails.actionkey;
            } else {
                jsonURL += '&actionkey=';
            }

            if (Helper.isValidValue(actionDetails.Xactionindex)) {
                jsonURL += '&Xactionindex=' + actionDetails.Xactionindex;
            } else {
                jsonURL += '&Xactionindex=';
            }

            if (Helper.isValidValue(actionDetails.errorcode)) {
                jsonURL += '&errorcode=' + actionDetails.errorcode;
            } else {
                jsonURL += '&errorcode=';
            }

            if (Helper.isValidValue(actionDetails.errormsg)) {
                jsonURL += '&errormsg=' + actionDetails.errormsg;
            } else {
                jsonURL += '&errormsg=';
            }

            jsonURL += Logger.logGetCommonParams();
            Logger.printLog('data', 'videoview log jsonURL:', jsonURL);
            Logger.requestLog(jsonURL);
        }
    }

    // Logging the new video from the grid
    static logNewVideoView = (videoInfo: any) => {
        Logger.printLog('info', 'logNewVideoView: new video view from grid', '');
        let currVideoInfo = videoInfo;
        let jsonParams = 'q=videoview';
        jsonParams += Logger.logGetCommonParams();
        jsonParams += '&id=' + currVideoInfo['node_id'];
        jsonParams += '&type=' + currVideoInfo['type'];
        jsonParams += '&actiontype=' + currVideoInfo['actiontype'];
        jsonParams += '&actionkey=' + currVideoInfo['actionkey'];
        jsonParams += '&userid=' + currVideoInfo['uid'];
        jsonParams += '&duration=' + (currVideoInfo['runtime'] || 0);

        Logger.requestLog(jsonParams);
    }

    // Logging the close video from the grid
    static logCloseVideoView = (previousVideoInfoObj: any) => {
        let previousVideoInfo = previousVideoInfoObj.vodInfo;
        let wd = previousVideoInfoObj.watchDuration;
        Logger.printLog('info', 'logCloseVideoView: close video and back to grid / unregistered log at launch', '');
        let jsonParams = 'q=videoview';
        jsonParams += Logger.logGetCommonParams();

        jsonParams += '&previd=' + previousVideoInfo.node_id;
        jsonParams += '&prevtype=' + previousVideoInfo.type;
        jsonParams += '&prevactiontype=' + previousVideoInfo.actiontype;
        jsonParams += '&prevactionkey=' + previousVideoInfo.actionkey;
        jsonParams += '&prevuserid=' + previousVideoInfo.uid;
        jsonParams += '&prevduration=' + previousVideoInfo.runtime || 0;
        jsonParams += '&prevdurationwatched=' + Math.round(wd);
        Logger.requestLog(jsonParams);
    }

    // Logging the next video / prev video from player next/prev buttons
    static logNextPrevVideoView = (currVideoInfo: any, previousVideoInfoObj: any) => {
        let previousVideoInfo = previousVideoInfoObj.vodInfo;
        let wd = previousVideoInfoObj.watchDuration;

        Logger.printLog('info', 'logNextPrevVideoView: prev/next video from player', '');
        let jsonParams = 'q=videoview';
        jsonParams += Logger.logGetCommonParams();

        if (currVideoInfo) {
            jsonParams += '&id=' + currVideoInfo['node_id'];
            jsonParams += '&type=' + currVideoInfo['type'];
            jsonParams += '&actiontype=' + currVideoInfo['actiontype'];
            jsonParams += '&actionkey=' + currVideoInfo['actionkey'];
            jsonParams += '&userid=' + currVideoInfo['uid'];
            jsonParams += '&duration=' + (currVideoInfo['runtime'] || 0);
        }
        jsonParams += '&previd=' + previousVideoInfo.node_id;
        jsonParams += '&prevtype=' + previousVideoInfo.type;
        jsonParams += '&prevactiontype=' + previousVideoInfo.actiontype;
        jsonParams += '&prevactionkey=' + previousVideoInfo.actionkey;
        jsonParams += '&prevuserid=' + previousVideoInfo.uid;
        jsonParams += '&prevduration=' + previousVideoInfo.runtime || 0;
        jsonParams += '&prevdurationwatched=' + Math.round(wd);
        Logger.requestLog(jsonParams);
    }

    static requestLog = (params: any) => {
        const { appConfig, appState } = AppData as AppSetup;
        const logBaseUrl = appConfig?.useProxyForLog ? `${appConfig?.apiPath}` : appConfig?.logUrl
        var jsonURL = logBaseUrl + 'applogger.php?' + params;
        Logger.printLog('data', 'logView log jsonURL:', jsonURL);
        if (appState && appState.appUnload) {
            navigator.sendBeacon(jsonURL, "");
        } else {
            axios.get(jsonURL,{timeout: 2000})
        }
    }

    static logGetCommonParams = () => {
        return Helper.getLogCommonAppParams();
    }

    static logAdIdEvent = () => {
        const { platform, appState, appConfig } = AppData as AppSetup
        const appApiConfig = appState?.getAppApiConfig()


        if(!appConfig?.sendAdIdInUserLog) {
            return;
        }

        const ifa = platform?.getIFA()
        if (!ifa || ifa.trim() === '') {
            Logger.printLog('info', 'logAdIdEvent: IFA unavailable, skipping', '')
            return
        }

        const genre = appApiConfig?.appConfig?.genre?.toLowerCase()
        const agePolicy = platform?.getAgePolicy()
        if (genre === 'kids' || agePolicy === 'app:child') {
            Logger.printLog('info', 'logAdIdEvent: Kids context, skipping', '')
            return
        }

        

        let params = 'q=user'
        // params += '&contentsubtype=adid'
        // params += '&id=1';
        params += '&type=adid'
        params += '&actiontype=' + ifa
        params += '&actionkey= '
        params += '&Xactionindex='
        params += '&Yactionindex='
        params += '&errorcode='
        params += '&errormsg='
        // params += '&loginuserid='
        params += Logger.logGetCommonParams()

        Logger.printLog('data', 'logAdIdEvent payload:', params)
        Logger.requestLog(params)
    }

    static processUserAction = (action: any, actionkey = '', errorcode = null, errormsg = null) => {
        Logger.printLog('data', 'logger.processUserAction called...', [action, actionkey, errorcode, errormsg]);
        const { appConfig, appState } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        if (appConfig?.enableDetailedActionLog == false) {
            return;
        }



        appState.userAction.actiontype = action;
        appState.userAction.actionkey = appConfig?.siteId;

        try {
            if (action !== 'searchResultsLaunched'
                && action !== 'selectedAnOptionFromSelectScreen'
                && action !== 'appLaunched'
                && action !== 'launchingAppViaSeasonDeepLink'
                && action !== 'launchingAppViaMovieDeepLink'
                && action !== 'buildInitialized'
            ) {

                let grid = app.navigation.getCurrentGrid();


                appState.userAction.actionkey = actionkey!=='' ? actionkey : appConfig.siteId;
                if (grid) {
                    appState.userAction.Xactionindex = String(grid.getFocusInfo().foucsItem);
                    appState.userAction.Yactionindex = String(grid.getFocusInfo().focusRow);
                }
                /*if (app.appState.isShowsLoaded) {
                  const subChannels = appState.showList;
                  if (subChannels !== undefined && subChannels !== null && subChannels[appState.grid.currentRowFocus] !== undefined) {
                    appState.userAction.actionkey = subChannels[appState.grid.currentRowFocus].videos[0].actionkey;
                  }
                } else {
                  const subCategories = appState.subCategoryList;
                  if (subCategories !== undefined && subCategories !== null && subCategories[appState.grid.currentRowFocus] !== undefined) {
                    appState.userAction.actionkey = subCategories[appState.grid.currentRowFocus].videos[0].actionkey;
                  }
                }*/
            } else {

            }

            // following actions do not have extra attributes - launch, search, AppClosedByUser, showExitConfirmationWindow, userCanceledFromExitWindow, userExitedAppUsingExitWindow, selectedAnOptionFromSelectScreen,

            if (action == 'videoinfo'
                || action == 'playbarLaunch'
                || action == 'previousVideoButtonPressedOnPlayerUI'
                || action.indexOf('playPausePressedOnVideoPlayer') == 0
                || action == 'nextVideoButtonPressedOnPlayerUI'
                || action == 'showSearchPageOnPlayerUI'
                || action == 'infoButtonPressedOnVideoPlayer_ShowingInfo'
                || action == 'videoErrorState'
                || action == 'launchingAppViaSeasonDeepLink'
                || action == 'launchingAppViaMovieDeepLink'
                || action == 'playlistLaunch'
                || action == 'GotoHomescreenFromPlayer'
                || action == 'autoPlayingNextVideoOnComplete'
                || action == 'autoPlayingNextVideoOnErrorMp4'
                || action == 'autoPlayingNextVideoOnErrorHls'
                || action.indexOf('rewindButtonPressedOn') == 0
                || action.indexOf('forwardButtonPressedOn') == 0
                || action.indexOf('trickplay') == 0
                || action == 'previousButtonPressedOnRemote'
                || action == 'nextButtonPressedOnRemote'
                || action == 'hideInfoWindowOnPlayerUI'
                || action == 'showInfoWindowOnPlayerUI'
                || action == 'closedCaptionsHidden'
                || action == 'closedCaptionsShown'
                || action.indexOf('videoResumePopup') == 0
            ) {

                // get current video details
                var videoInfo = app.navigation.getCurrentVodInfo();
                if (!videoInfo) {
                    let grid = app.navigation.getCurrentGrid();
                    if (grid) {
                        videoInfo = grid.getItemAt(grid.getFocusInfo().focusRow, grid.getFocusInfo().foucsItem);
                    }
                }
                if (videoInfo !== '' && videoInfo !== null && videoInfo !== undefined) {
                    if (actionkey !== '') {
                        appState.userAction.actionkey = actionkey;
                    } else {
                        appState.userAction.actionkey = videoInfo.actionkey;
                    }
                }

                if (action == 'videoErrorState') {
                    actionkey = encodeURI(actionkey);
                    appState.userAction.actionkey = actionkey;
                }



            } else if (action == 'MoveFocusToFirstInRow'
                || action == 'fetchMoreItemsOnGrid'
                || action == 'videoItemSelectedFromGrid'
                || action == 'lastVideoItemSelectedOfRowFromGrid'
            ) {
                // get currently focused thumbnail details


            } else if (action == 'showingSearchScreenOnGrid'
                || action == 'NavigateToHomeScreen'
                || action == 'MoveFocusToTopRow'
                || action == 'fetchmore'
                || action == 'showClickedOnGrid'
            ) {


            } else if (action == 'newL1Clicked') {
                appState.userAction.actionkey = decodeURI(actionkey);
            } else if (action == 'launch') {
                appState.userAction.actionkey = decodeURI(actionkey !== '' ? actionkey : appConfig.siteId);
            } else if (action == 'userExitedViaRemoteDirectly') {
                //appState.userAction.actionkey = decodeURI(actionkey);
            } else if (action == 'newChildAppOpenedOnGrid' || action == 'backPressedOnVideoScene_goingBackToPreviousApp') {
                appState.userAction.actionkey = decodeURI(actionkey);
            } else if (action == 'searchResultsLaunched') {
                appState.userAction.actionkey = decodeURI(actionkey);
            } else if (action == 'adBreakStart' || action == 'adBreakEnd') {
                appState.userAction.actionkey = decodeURI(actionkey !== '' ? actionkey : appConfig.siteId);
            } else if (action.indexOf('deeplinkRawData')>=0 ) {
                appState.userAction.actionkey = decodeURI(actionkey !== '' ? actionkey : appConfig.siteId);
            } else if (action == 'InApp_newChildAppOpenedOnGrid' ||
                action == 'InApp_GoingBackTo_PreviousApp_viaOnScreenButton' ||
                action == 'InApp_GoingBackTo_MainApp_Home' ||
                action == 'InApp_GoingBackTo_PreviousApp_Home'
            ) {
                appState.userAction.actionkey = decodeURI(actionkey !== '' ? actionkey : appConfig.siteId);
            } else if (action.indexOf('playbackStarted')>=0 ) {
                appState.userAction.actionkey = decodeURI(actionkey !== '' ? actionkey : appConfig.siteId);
            } else if (action.indexOf('networkReconnected')>=0 ) {
                appState.userAction.actionkey = decodeURI(actionkey !== '' ? actionkey : appConfig.siteId);
            } 
            if (errorcode !== null) { appState.userAction.errorcode = errorcode; } else { appState.userAction.errorcode = ''; }
            if (errormsg !== null) { appState.userAction.errormsg = errormsg; } else { appState.userAction.errormsg = ''; }

            if (appState.userAction.actiontype !== '') {
                Logger.logUserAction(appState.userAction);
            }
        } catch (e) {
            Logger.printLog('error', 'logger catch error', e);
        }
    }

    static printLog = (type: any, message: any, vars: any) => {
        const { appConfig } = AppData as AppSetup;

        if (appConfig?.consoleDebugLog == true) {
            var commonStyle = 'color:#fff; padding:2px 6px;';
            vars = (vars || '');
            if (type == 'log') {
                console.log("%c" + message, "background-color:#34495e;" + commonStyle, vars);
            } else if (type == 'info') {
                console.log("%c" + message, "background-color:#3498db;" + commonStyle, vars);
            } else if (type == 'error') {
                console.log("%c" + message, "background-color:#c0392b;" + commonStyle, vars);
            } else if (type == 'data') {
                console.log("%c" + message, "background-color:#8e44ad;" + commonStyle, vars);
            } else if (type == 'adlogfw') {
                console.log("%c" + message, "background-color:#8e44ad;" + commonStyle, vars);
            }
        }

    }

    static logSourceInfo = (isAppResume = false) => {
        // actiontype=appLaunched;
        // source=auto-run-dev;
        // appType=clientBased;
        // instantOnRunMode=foreground;
        // lastExitReason=EXIT_UNKNOWN;
        // deepLinkParameters_InvalidOrPatternDataMisMatch;
        // contentID=Invalid;
        // mediaType=Invalid
        // &actionkey=

        // actiontype=appLaunched;source=external-control;appType=clientBased;instantOnRunMode=foreground;lastExitReason=EXIT_UNKNOWN;testAndLaunchWithDeepLinkParameters_ValidPatternMatch;contentID=ro:listoflist:8153::dy-10238423-1447600;mediaType=season&actionkey= &Xactionindex=0&Yactionindex=0

        let jsonURL = '';
        //jsonURL = jsonURL + logger.logGetCommonParams();

        // prepare the launch info string
        let launchInfoStr = '';

        launchInfoStr += 'appLaunched;';

    Logger.printLog('data', 'logger.logSourceInfo called...');
    const { appConfig, appState } = AppData as AppSetup;
    const app: AppModel = appState?.getApp()!;
    if (appState && appState.playlistPlayMode == true) {
			launchInfoStr += 'source=' + appState.deeplinks.sourceType + ';';
			launchInfoStr += 'testAndLaunchWithDeepLinkParameters_ValidPatternMatch;';
			launchInfoStr += 'contentID=' + appState.deeplinks.playId + ';';
			launchInfoStr += 'mediaType=' + appState.deeplinks.type + ';';
		} else {
			launchInfoStr += `source=${isAppResume == true ? 'instance-resume' : 'homescreen'};`;
			launchInfoStr += 'deepLinkParameters_InvalidOrPatternDataMisMatch;';
			launchInfoStr += 'contentID=Invalid;';
			launchInfoStr += 'mediaType=Invalid;';
		}

        launchInfoStr += 'appType=clientBased;';
        launchInfoStr += 'instantOnRunMode=foreground;';
        launchInfoStr += 'lastExitReason=EXIT_UNKNOWN;';
        launchInfoStr += 'appType=clientBased';

        jsonURL += '&actiontype=' + launchInfoStr;
        jsonURL += '&actionkey=' + appConfig.siteId;
        jsonURL += '&Xactionindex=';
        jsonURL += '&Yactionindex=';
        jsonURL += Logger.logGetCommonParams();

        //logger.printLog('data', 'source log jsonURL:', jsonURL);
        Logger.printLog('data', 'logView log jsonURL:', jsonURL);
        Logger.requestLog(jsonURL);
    }

    /**************** ADS **************/

    static getCommonLogString = () => {

        const { appConfig, platform } = AppData as AppSetup;
        var jsonURL = '';
        var baseSiteId = Helper.getCookie("baseAppId");

        // var siteName = appApiConfig.appConfig.site_name.replace(/\s+/g, '-');

        // device and app specific values
        if (appConfig.isXBox == true) {
            jsonURL += '&device=xbox';
        }
        if (platform?.getDeviceId() !== undefined) {
            jsonURL += '&deviceId=' + platform?.getDeviceId();
        } else {
            jsonURL += '&deviceId=';
        }

        jsonURL += '&auth-token=' + appConfig.platform_id;
        jsonURL += '&appid=' + platform?.getDeviceId();
        jsonURL += '&appId=' + appConfig.appId;
        jsonURL += '&version=' + appConfig.apiVersion;
        jsonURL += '&apptype=' + Helper.getAppType();

        if (typeof baseSiteId !== 'undefined' && baseSiteId !== undefined && baseSiteId !== '' && baseSiteId !== null) {
            jsonURL += '&siteId=' + baseSiteId;
        } else {
            jsonURL += '&siteId=' + appConfig.siteId;
        }

        jsonURL += '&format=json';
        jsonURL += '&deviceModel=' + platform?.getFullModel() + '_' + platform?.getPartnerId();
        jsonURL += '&firmware=' + platform?.getFirmwareVersion();
        jsonURL += '&build=' + 'clientBased';

        return jsonURL;

    }


    static logAdView = (adDetails: any, transactionId='') => {
        Logger.printLog('info', 'calling ad logger', '');
        const { appConfig, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        const apiBaseUrl = appConfig?.logUrl
        const vodInfo = app?.navigation.getCurrentVodInfo();
        try {
            var jsonURL = apiBaseUrl + 'applogger.php?q=adview';
            //var jsonURL = Helper.getApploggerUrl() + 'q=adview';
            jsonURL = jsonURL + Logger.getCommonLogString();
            jsonURL += '&uid=' + vodInfo['uid'];
            jsonURL += '&id=' + vodInfo['node_id'];
            jsonURL += '&adProvider=' + adDetails.adProviderName;
            jsonURL += '&adAvailable=' + adDetails.adAvailable;
            jsonURL += '&adPlayed=' + adDetails.adPlayed;
            jsonURL += '&priority=' + adDetails.adPriority;
            jsonURL += '&adType=' + adDetails.adType;
            if(transactionId != ''){
                jsonURL += '&transactionId=' + transactionId;
            } else {
                jsonURL += '&transactionId=' + Helper.guid(vodInfo['node_id']);
            }
            // jsonURL += '&transactionId=' + helper.guid();
            jsonURL += '&adProviderName=' + adDetails.adProvider;
            // jsonURL += '&event=complete';
            jsonURL += '&isPreAdDetails=false';
            if (adDetails.adId !== undefined) {
                jsonURL += '&adid=' + adDetails.adId;
            }
            if (adDetails.adTitle !== undefined) {
                jsonURL += '&adtitle=' + adDetails.adTitle;
            }
            jsonURL += '&isAd=true';
            jsonURL += '&session_id=' + appConfig?.sessionId;

            Logger.printLog('data', 'ad jsonURL:', jsonURL);
            fetchData(jsonURL).then((resp: any) => {
                Logger.printLog('data', 'ad jsonURL response: ', resp);
            })
            // $.get(jsonURL, function (resp) {
            // 	Logger.printLog('data', 'ad jsonURL response:', resp);
            // });
        } catch (e) {
            Logger.printLog('error', 'error in logging ad view', e);
        }
    }
}
